module.exports = __webpack_public_path__ + "img/logo.202104212035-white.40c1555e.png";